import { useLocation } from "react-router-dom";
import SEO from "./componets/SEO";
import { seoData } from "./seoConfig";

const SEOHandler = () => {
    const location = useLocation();

    let path = location.pathname;

    // 🔥 Fix 1: normalize empty path
    if (!path || path === "") {
        path = "/";
    }

    // 🔥 Fix 2: remove trailing slash (except root)
    if (path !== "/" && path.endsWith("/")) {
        path = path.slice(0, -1);
    }

    const currentSEO = seoData[path];

    if (!currentSEO) return null;

    return <SEO {...currentSEO} />;
};

export default SEOHandler;
